import React, { useEffect, useState } from "react";
import { fetchOpinion } from "../services/opinionService";
import { timeDifference } from "../utils/timeUtils";
import { SectionHeader } from "./redesign/Sections";

function OpinionCard({ item }) {
  return (
    <a
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex flex-col overflow-hidden rounded-card border border-line bg-surface transition hover:shadow-md"
    >
      <div className="flex flex-1 flex-col p-4">
        {/* author is the heart of a column */}
        {item.author && (
          <span className="font-head text-[12px] font-bold uppercase tracking-wider text-ai">
            {item.author}
          </span>
        )}
        <h3 className="mt-1 line-clamp-3 font-head text-[16px] font-bold leading-snug tracking-tight text-ink group-hover:underline">
          {item.title}
        </h3>
        {item.summary && (
          <p className="mt-2 line-clamp-3 text-[13px] leading-relaxed text-sub">
            {item.summary}
          </p>
        )}
        <div className="mt-auto pt-3 text-[11.5px] text-sub">
          <span className="font-head font-semibold text-brand">
            {item.portal}
          </span>
          {item.publishedAt && <> · {timeDifference(item.publishedAt)}</>}
        </div>
      </div>
    </a>
  );
}

export default function OpinionPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchOpinion(60).then((list) => {
      if (cancelled) return;
      setItems(list);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <SectionHeader title="Kolumna & Opinione" />

      {loading ? (
        <p className="text-[14px] text-sub">Po ngarkohen kolumnat…</p>
      ) : items.length === 0 ? (
        <p className="text-[14px] text-sub">
          Nuk ka kolumna për momentin. Provoni më vonë.
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
          {items.map((it) => (
            <OpinionCard key={it.link} item={it} />
          ))}
        </div>
      )}
    </div>
  );
}
